import { element } from 'angular';
import { RootState } from 'src/react/root/state/RootState';

export function ngSelect(state: RootState, service: string): unknown {
    const $injector = element(document).injector();
    return $injector.get(service);
}
